<template>
  <div>
    <template>
      <v-form ref="form" lazy-validation>
        <v-col color="white" cols="12" sm="3" class="selectBoxPadding">
          <v-select
            :items="golfSelect"
            class="height50"
            item-value="golf_code"
            item-text="golf_name"
            v-model="golfCode"
            label="ゴルフ場名"
            @input="GolfCourseSelectSearch"
            :rules="[rules.required]"
          ></v-select>
        </v-col>
        <v-col color="white" cols="12" sm="3" class="selectBoxPadding">
          <v-select
            :items="selectTaxType"
            class="height50"
            item-value="code"
            item-text="code_name"
            v-model="taxID"
            label="税種別"
            @input="GetTaxList"
          ></v-select>
        </v-col>
      </v-form>
    </template>
    <v-data-table
      :headers="headers"
      :items="desserts"
      class="golfGroupTbody"
      hide-default-footer
    >
      <template v-slot:[`item.tax_division`]="{ item }">
        <span v-if="item.tax_division == 1">%</span>
        <span v-if="item.tax_division == 2">円</span>
      </template>
      <template v-slot:[`item.flags`]="{ item }">
        <v-simple-checkbox v-model="item.flags" disabled/>
      </template>
      <template v-slot:[`item.Btn`]="{ item }">
        <v-btn color="green darken-4" text @click="EditModal(item)" class="editBtn" :disabled="btn[0].isActive || item.butnflag">変更</v-btn>
      </template>
    </v-data-table>
    <v-pagination
      class="my-2"
      v-model="page"
      :length="pageCount"
      :total-visible="7"
      @input="clickPagination"
    />
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-4" text @click="AddModal" :disabled="btn[1].isActive">追加</v-btn>
    </v-card-actions>
    <TaxModal ref="TaxModalView" v-show="showTaxModal" v-on:from-Dialog="OnCloseEditModal"/>
  </div>
</template>

<script>
import validater from '@/lib/validater';
// モーダル
import TaxModal from './modal/TaxModal';

// mixins
import { authorityMixin } from '@/views/authorityMixin';
import { golfCourseMixin } from '@/mixins/golfCourse';
import { codeListMixin } from '@/mixins/codeList';
// graghql
import { GET_CODE_LIST } from '@/constants/codelist';
import { CODE_MASTER } from '../../config';

import { GET_ALL_TAX_LIST } from '@/constants/tax';

export default {
    components: {
        TaxModal
    },
    mixins: [
        authorityMixin,
        golfCourseMixin,
        codeListMixin
    ],
    data () {
        return {
            showTaxModal: false,
            page: 1,
            golf_courses: null,
            golfCode: '',
            count: null,
            pageCount: 0,
            begin_row: 0,
            limit_rows: 10,
            loginUser: null,
            taxID: null,
            taxDivision: null,
            golfSelect: [],
            selectTaxType: [],
            taxType: [],
            list: [],
            desserts: [],
            admin: {
                user_id: '',
                user_div: '',
                golf_code: ''
            },
            // v-data-tableのヘッダー
            headers: [
                { text: '開始日', value: 'start_date', align: 'center', sortable: false },
                { text: '区分', value: 'tax_division', align: 'center', sortable: false },
                { text: '税', value: 'tax', align: 'center', sortable: false },
                { text: '', value: 'Btn', sortable: false }
            ],
            btn: [
                { element_id: '003', element_name: '税編集', isActive: false },
                { element_id: '004', element_name: '税追加', isActive: false }
            ],
            vue_id: 'SCR0030',
            rules: {
                required: value => validater.checkEmptyString(value) || this.$t('error.validation.required.any')
            }
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize: async function () {
            this.GetTaxCodeList();
            this.admin = await this.getLoginAdmin();
            this.golfSelect = await this.getGolfCourseList();
            if (String(this.admin.user_div) === CODE_MASTER.AUTHORITY_SYSTEM_ADMIN) {
                this.golfSelect.unshift({ golf_code: CODE_MASTER.AUTHORITY_SYSTEM_ADMIN_GOLF_CODE, golf_name: '全て' });
            }
            this.golfCode = this.golfSelect[0].golf_code;
            await this.getAuthorityList();
            await this.GolfCourseSelectSearch();
        },
        /** --------------------------------------------
        * 税種別コードを取得
        * -------------------------------------------- */
        GetTaxCodeList () {
            this.$apollo.query({
                query: GET_CODE_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    code_key: 'tax_type',
                    default_display: 0
                }
            }).then(res => {
                this.taxType = res.data.GetCodeList.CodeList;
            });
        },
        /** --------------------------------------------
        * ゴルフ場選択時の検索動作
        * -------------------------------------------- */
        async GolfCourseSelectSearch () {
            this.selectTaxType = [];
            if (this.golfCode === CODE_MASTER.AUTHORITY_SYSTEM_ADMIN_GOLF_CODE) {
                for (var i = 0; i < this.taxType.length; i++) {
                    if (this.taxType[i].reserve1 === '1') {
                        this.selectTaxType.push(this.taxType[i]);
                        this.taxID = this.selectTaxType[0].code;
                    }
                }
            } else {
                for (var j = 0; j < this.taxType.length; j++) {
                    if (this.taxType[j].reserve1 === '2') {
                        this.selectTaxType.push(this.taxType[j]);
                        this.taxID = this.selectTaxType[0].code;
                    }
                }
            }
            this.GetTaxList();
        },
        /** --------------------------------------------
        * 税一覧を取得
        * -------------------------------------------- */
        async GetTaxList () {
            let res = await this.$apollo.query({
                query: GET_ALL_TAX_LIST,
                fetchPolicy: 'no-cache',
                variables: {
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_code: this.golfCode,
                    tax_id: this.taxID,
                    limit_rows: this.limit_rows,
                    begin_row: this.begin_row
                }
            });
            this.desserts = [];
            var latestStartDate = res.data.GetTaxListByPlanMaster.latestStartDate;
            this.desserts = res.data.GetTaxListByPlanMaster.TaxMasterList;
            for (var k = 0; k < this.desserts.length; k++) {
                this.desserts[k].tax = Math.floor(this.desserts[k].tax);
                this.desserts[k].butnflag = true;
                if (this.taxID !== CODE_MASTER.TAX_TYPE_CONSUMPTION) {
                    this.desserts[k].tax = Number(this.desserts[k].tax).toLocaleString();
                }
                if (this.desserts[k].start_date === latestStartDate) {
                    this.desserts[k].butnflag = false;
                }
            }
            if (!this.desserts) {
                this.desserts.slice(-1)[0].butnflag = false;
            }
            const count = res.data.GetTaxListByPlanMaster.count;
            this.pageCount = Math.ceil(count / 10);
        },
        /** --------------------------------------------
        * 変更画面
        * -------------------------------------------- */
        EditModal (item) {
            this.showTaxModal = true;
            this.$refs.TaxModalView.EditModal(item, this.selectTaxType, this.admin.user_div);
        },
        /** --------------------------------------------
        * 追加画面
        * -------------------------------------------- */
        AddModal () {
            if (this.$refs.form.validate()) {
                this.showTaxModal = true;
                this.$refs.TaxModalView.AddModal(this.golfCode, this.selectTaxType, this.admin.user_div, this.taxID);
            }
        },
        /** --------------------------------------------
        * 画面閉じる
        * -------------------------------------------- */
        OnCloseEditModal () {
            this.GetTaxList();
            this.showTaxModal = false;
        },
        /** --------------------------------------------
        * ページネーション
        * -------------------------------------------- */
        clickPagination: function () {
            this.begin_row = this.page * this.limit_rows - this.limit_rows;
            this.GetTaxList();
        }
    }
};
</script>

<style scoped>
    .v-data-table ::v-deep td{
        max-width: 500px;
    }

    .v-data-table ::v-deep i{
        font-size: 15px;
    }

    .editBtn{
        color: #1B5E20;
        background: Transparent;
        text-decoration: underline;
        margin-right: 20px;
    }

    .deleteBtn {
        color: #d63200;
        background: Transparent;
        text-decoration: underline;
    }

    .selectBoxPadding{
        padding: 0px 0px 0px 13px;
    }

    .height50{
        height: 50px;
    }

</style>
